module.exports = __webpack_public_path__ + "static/assets/fa0038ea1a10da378c83e4f6ebe839ea.png";